import { TransactionExtraType } from "../enums/global.enums";

export function transactionExtraTypePipe(value: string): string {
    switch (value) {
        case TransactionExtraType.WaterInvoiceMinusDeposit: return "Thanh toán 1 phần hoá đơn";
        case TransactionExtraType.Deposit: return "Đặt cọc";
        case TransactionExtraType.Refund: return "Hoàn tiền";
        case TransactionExtraType.Payment: return "Thanh toán";
        case TransactionExtraType.EnvironmentFee: return "Xử lý sai sót";
        case TransactionExtraType.EmployeeDepositDebit: return "Ghi nợ thu cọc nhân viên";
        case TransactionExtraType.EmployeeWaterInvoice: return "Ghi nợ thu tiền nước nhân viên";
        case TransactionExtraType.EmployeeDebt: return "Gạch nợ nhân viên";
        default: return value;
    }
}

export const TRANSACTION_EXTRA_TYPES = [
    TransactionExtraType.WaterInvoiceMinusDeposit,
    TransactionExtraType.Deposit,
    TransactionExtraType.Refund,
    TransactionExtraType.Payment,
    TransactionExtraType.EnvironmentFee,
    TransactionExtraType.EmployeeDepositDebit,
    TransactionExtraType.EmployeeWaterInvoice,
    TransactionExtraType.EmployeeDebt,
]